import CreateUpdateSaleAccounts from "../SalesAccounts/components/CreateUpdateSaleAccounts";
import { useTranslation } from "react-i18next";
import { Space } from "antd";
import RemoveButton from "../SalesAccounts/components/RemoveButton";
import type { ApolloQueryResult } from "@apollo/client";

type RefetchClientVatAccountingConfigs = (
  variables?: Partial<ListClientVatAccountingConfigsVars> | undefined,
) => Promise<ApolloQueryResult<ListClientVatAccountingConfigsResponse>>;

export default function useSalesAccountsTableColumns(refetch: RefetchClientVatAccountingConfigs) {
  const { t } = useTranslation();

  return [
    {
      title: t("Client"),
      dataIndex: "client",
      key: "client",
      render: (_text: unknown, record: ListClientVatAccountingConfigsData) => {
        return record?.clientVatType ? (
          <span>{`${record?.clientVatType?.code} - ${record?.clientVatType?.name}`}</span>
        ) : (
          "*"
        );
      },
    },
    {
      title: t("Product"),
      dataIndex: "product",
      key: "product",
      render: (_text: unknown, record: ListClientVatAccountingConfigsData) => {
        return record?.productType ? (
          <span>{`${record?.productType?.code} - ${record?.productType?.name}`}</span>
        ) : (
          "*"
        );
      },
    },
    {
      title: t("Counterpart code"),
      dataIndex: "counterpartCode",
      key: "counterpartCode",
    },
    {
      dataIndex: t("Action"),
      key: "action",
      title: "Action",
      align: "center",
      width: "100px",
      render: (_text: unknown, record: ListClientVatAccountingConfigsData) => {
        return (
          <Space size="small" direction="horizontal" className="centered">
            <>
              {record?.editable && <RemoveButton id={record.id} refetch={refetch} />}
              <CreateUpdateSaleAccounts
                onlyCanEditCounterpart={!record?.editable}
                id={record.id}
                refetch={refetch}
              />
            </>
          </Space>
        );
      },
    },
  ];
}
